var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeSignalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 36,
    viewBox: "0 0 64 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.0093 6.20906L31.5335 14.2982C31.3523 14.6211 30.5369 15.94 30.256 16.1521C29.5131 17.0469 28.4893 17.6371 27.3476 17.8401C27.0758 17.9324 26.0067 17.9877 25.7077 17.9877H10.8126L0.909668 35.9001H15.7957C16.6565 35.8908 19.7914 35.7156 20.5706 35.402C23.6601 34.7655 26.3963 32.6718 27.9909 29.7847L32.4667 21.6956C32.6479 21.3728 33.4634 20.0538 33.7442 19.8417C34.4872 18.9469 35.5201 18.3566 36.6617 18.1445C36.9335 18.0522 37.9935 17.9969 38.2925 17.9969H53.1876L63.0905 0.09375H48.2135C47.3528 0.102974 44.2179 0.278223 43.4387 0.591829C40.3402 1.21904 37.6039 3.32203 36.0093 6.20906Z",
    fill: "#FF9332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeSignalLogo);
export default __webpack_public_path__ + "static/media/orange-signal-logo.fdd6669d6e707de2e1d96415012b8f41.svg";
export { ForwardRef as ReactComponent };